import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import { getStatusChangesList } from '../../utils/tickets';

import s from 'components/capacityInfo/capacityInfo.scss';

export default class CapacityInfo extends Component {
	render(props) {
		const { offline, screening, tickets } = props;

		const capacity = screening?.capacity || 0;
		const scanned = tickets?.filter(e => e.status === 'admitted').length;
		const unsyncedScans = offline && getStatusChangesList().filter(e => e.status === 'admitted').length;
		// const currentUsage = Math.min(scanned / capacity, 1);
		const currentUsage = scanned / capacity;

		const cells = offline ? [
			{ value: capacity || '?', text: 'Seating capacity' },
			{ value: unsyncedScans, text: 'Tickets scanned since last online' },
			{ value: '', text: 'Check seating capacity separately' },
		] : [
			{ value: `${scanned}/${capacity || '?'}`, text: 'Seats taken' },
			{ value: capacity ? Math.max(capacity - scanned, 0) : '?', text: 'Seats left' },
			{ value: capacity ? `${Math.round(100 * currentUsage)}%` : '?%', text: 'Capacity', warning: capacity && currentUsage >= .95 },
		];

		return (
			<div class={joinClasses(s.root, offline && s.offline)}>
				{cells.map(cell => (
					<div class={joinClasses(s.cell, cell.warning && s.warning)}>
						<div class={s.value}>{cell.value}</div>
						<div class={s.text}>{cell.text}</div>
					</div>
				))}
			</div>
		);
	}
}